import ContactItem from "./ContactItem";

export {ContactPersonItem as default};

/**
* Contact Person Item
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class ContactPersonItem extends ContactItem {
  /**
   * Email
   *
   * @public
   *
   * @type {String|undefined}
   *
   * @since 7.0.0
   */
  email;

  /**
   * Mobile
   *
   * @public
   *
   * @type {String|undefined}
   *
   * @since 7.0.0
   */
  mobile_phone;

  /**
   * Address
   *
   * @public
   *
   * @type {String|undefined}
   *
   * @since 7.0.0
   */
  home_address;

  /**
   * Company
   *
   * @public
   *
   * @type {String|undefined}
   *
   * @since 7.0.0
   */
  company;

  /**
   * Birth Date
   *
   * @public
   *
   * @type {String|undefined}
   *
   * @since 7.0.0
   */
  birth_date;

  /**
   * Notes
   *
   * @public
   *
   * @type {String|undefined}
   *
   * @since 7.0.0
   */
  notes;

  /**
   * Contact type
   *
   * @public
   * @readonly
   *
   * @type {String|undefined}
   *
   * @since 7.0.0
   */
  type = 'person';

  /**
   * Groups list
   *
   * @public
   * @readonly
   *
   * @type {Array}
   *
   * @since 7.0.0
   */
  groups = [];


  /**
   * Person recipient string representation
   *
   * @public
   *
   * @type {String}
   *
   * @since 7.0.0
   */
  recipient;
}